"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newCatalogDateDataset = exports.CatalogDateDatasetBuilder = exports.newCatalogDateAttribute = exports.CatalogDateAttributeBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var sdk_model_1 = require("@gooddata/sdk-model");
var builder_1 = require("../builder");
var attributeFactory_1 = require("../metadata/attributeFactory");
var displayFormFactory_1 = require("../metadata/displayFormFactory");
var dataSetFactory_1 = require("../metadata/dataSetFactory");
/**
 * Catalog date attribute builder
 * See {@link Builder}
 *
 * @beta
 */
var CatalogDateAttributeBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogDateAttributeBuilder, _super);
    function CatalogDateAttributeBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogDateAttributeBuilder.prototype.granularity = function (granularity) {
        this.item.granularity = granularity;
        return this;
    };
    CatalogDateAttributeBuilder.prototype.attribute = function (attributeOrRef, modifications) {
        if (!sdk_model_1.isAttributeMetadataObject(attributeOrRef)) {
            this.item.attribute = attributeFactory_1.newAttributeMetadataObject(attributeOrRef, modifications);
        }
        else {
            this.item.attribute = attributeOrRef;
        }
        return this;
    };
    CatalogDateAttributeBuilder.prototype.defaultDisplayForm = function (displayFormOrRef, modifications) {
        if (!sdk_model_1.isAttributeDisplayFormMetadataObject(displayFormOrRef)) {
            this.item.defaultDisplayForm = displayFormFactory_1.newAttributeDisplayFormMetadataObject(displayFormOrRef, modifications);
        }
        else {
            this.item.defaultDisplayForm = displayFormOrRef;
        }
        return this;
    };
    return CatalogDateAttributeBuilder;
}(builder_1.Builder));
exports.CatalogDateAttributeBuilder = CatalogDateAttributeBuilder;
/**
 * Catalog date attribute factory
 *
 * @param modifications - catalog date attribute builder modifications to perform
 * @returns created catalog date attribute
 * @beta
 */
exports.newCatalogDateAttribute = function (modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(CatalogDateAttributeBuilder, {}, modifications);
};
/**
 * Catalog date dataset builder
 * See {@link Builder}
 *
 * @beta
 */
var CatalogDateDatasetBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogDateDatasetBuilder, _super);
    function CatalogDateDatasetBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogDateDatasetBuilder.prototype.relevance = function (relevance) {
        this.item.relevance = relevance;
        return this;
    };
    CatalogDateDatasetBuilder.prototype.dateAttributes = function (dateAttributes) {
        this.item.dateAttributes = dateAttributes;
        return this;
    };
    CatalogDateDatasetBuilder.prototype.dataSet = function (dataSetOrRef, modifications) {
        if (!sdk_model_1.isDataSetMetadataObject(dataSetOrRef)) {
            this.item.dataSet = dataSetFactory_1.newDataSetMetadataObject(dataSetOrRef, modifications);
        }
        else {
            this.item.dataSet = dataSetOrRef;
        }
        return this;
    };
    return CatalogDateDatasetBuilder;
}(builder_1.Builder));
exports.CatalogDateDatasetBuilder = CatalogDateDatasetBuilder;
/**
 * Catalog date dataset factory
 *
 * @param modifications - catalog date dataset builder modifications to perform
 * @returns created catalog date dataset
 * @beta
 */
exports.newCatalogDateDataset = function (modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(CatalogDateDatasetBuilder, { type: "dateDataset" }, modifications);
};
//# sourceMappingURL=dateDatasetFactory.js.map